import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

const TrainerSocialLink = () => {
  const [platform, setPlatform] = useState("");
  const [url, setUrl] = useState("");
  const navigate = useNavigate();

  const trainerId = localStorage.getItem("trainerId");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newSocialLink = {
      trainer: trainerId,
      platform,
      url,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/social_link",
        newSocialLink
      );
      if (response.status === 201 || response.status === 200) {
        console.log("Social link added:", response.data);
        navigate(-1);
      } else {
        console.error("Failed to create social link:", response);
      }
    } catch (error) {
      console.error("Error creating social link:", error);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      <div className="container py-4">
        <div className="card mx-auto shadow" style={{ maxWidth: "480px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Add Social Link</h5>
          </div>
          <form className="card-body" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="platform" className="form-label">
                Platform
              </label>
              <input
                type="text"
                id="platform"
                className="form-control"
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
                placeholder="e.g. LinkedIn, GitHub"
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="url" className="form-label">
                URL
              </label>
              <input
                type="url"
                id="url"
                className="form-control"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com/your-profile"
                required
              />
            </div>

            <div className="modal-footer px-0">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Link
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TrainerSocialLink;
